<template>
  <div id="config-add-ons-wrapper">
    <item-tile
      v-for="(item, index) in addOns"
      :key="index"
      class="add-on-item"
      :heading="item.name"
      :photo="item.photo"
      :selected="true"
      :secondaryIcons="['pencil']"
      @primary-icon-clicked="initiateDelete(item, index)"
      @secondary-icon-clicked="initiateEdit(item, index)"
    />
    <item-tile
      class="add-on-item"
      :selected="false"
      heading="Add New Add On"
      @click="toggleCreationActive"
    />
    <add-on-creation
      v-if="creationActive"
      :add-on="edit.addOn"
      @close="toggleCreationActive"
      @add-add-on="callDb"
    />
    <add-on-delete
      v-if="del.addOn"
      :subject="del.addOn"
      :processing="del.processing"
      @close="closeDelete"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import AddOnCreation from "./Modals/AddOns/AddOnCreation.vue";
import AddOnDelete from "./Modals/AddOns/Delete.vue";
import ItemTile from "@/Components/UI/ItemTile.vue";
export default {
  data() {
    return {
      creationActive: false,
      deleteActive: false,
      edit: {
        addOn: undefined,
        index: undefined,
      },
      del: {
        processing: false,
        addOn: undefined,
        index: undefined,
      },
    };
  },
  computed: {
    addOns() {
      return this.$store.getters.addOns;
    },
  },
  methods: {
    toggleCreationActive() {
      this.creationActive = !this.creationActive;
    },
    initiateEdit(item, index) {
      this.edit.addOn = item;

      this.edit.index = index;
      this.toggleCreationActive();
    },
    initiateDelete(item, index) {
      this.del.addOn = item;
      this.del.index = index;
    },
    closeDelete() {
      this.del = {
        processing: false,
        addOn: undefined,
        index: undefined,
      };
    },
    async confirmDelete() {
      this.del.processing = true;
      await this.$store.commit("updateConfig", {
        index: this.del.index,
        category: "addOns",
        operation: "delete",
        api_version: this.$store.state.businessSettings.api_version,
      });
      this.closeDelete();
    },
    async callDb(subject) {
      let dbAddOn = {
        name: subject.name,
        description: subject.description,
        priceOption: subject.priceOption,
        pricing: subject.pricing,
        employeesRequired: subject.employeesRequired,
        photo: subject.photo,
        id: subject.id ? subject.id : "addOn" + new Date().getTime(),
        forms: subject.forms
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
        contracts: subject.contracts
          .filter((x) => {
            return x;
          })
          .map((x) => {
            return x.id;
          }),
      };
      if (dbAddOn.photo && typeof dbAddOn.photo !== "string") {
        await this.$store.dispatch("addPhoto", dbAddOn.photo).then((res) => {
          dbAddOn.photo = res;
        });
      }
      let updatePacket;
      if (this.edit.index) {
        updatePacket = {
          key: {
            userId: this.$store.state.user.userId,
            tenantId: this.$store.state.user.tenantId,
          },
          subject: dbAddOn,
          index: this.edit.index,
          category: "addOns",
          operation: "edit",
          api_version: this.$store.state.businessSettings.api_version,
        };
      } else {
        updatePacket = {
          key: {
            userId: this.$store.state.user.userId,
            tenantId: this.$store.state.user.tenantId,
          },
          subject: dbAddOn,
          category: "addOns",
          operation: "add",
          api_version: this.$store.state.businessSettings.api_version,
        };
      }
      await this.$store.dispatch("updateConfig", updatePacket);
      this.toggleCreationActive();
    },
  },
  created() {},
  components: {
    ItemTile,
    AddOnCreation,
    AddOnDelete,
  },
  props: [],
};
</script>
<style scoped>
@media screen {
  #config-add-ons-wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-items: flex-start;
    box-sizing: border-box;
  }

  .add-on-item {
    margin: 20px;
    background-color: var(--secondaryColor);
  }
  @media (min-width: 800px) {
    .add-on-item {
      margin: 30px;
    }
  }
}
</style>
